import React, { useEffect, useState } from 'react';
import { Container, Alert, Spinner, Card, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DataManager } from '../core/data-manager';
import { LoginManager } from '../core/login-manager';
import { LanguageProvider } from '../core/language-provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function Dashboard() {

    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const userInfo = LoginManager.getUserInfo()

    useEffect(() => {
    }, []);



    return (
        <>
            {parseInt(userInfo?.level) !== 3 ? <>

                <Container fluid className='mt-5'>
                    <Row>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'primary'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Ordini cliente <FontAwesomeIcon icon="users" className='ms-1' /></Card.Title>
                                    Gestisci tutti gli ordini cliente.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="/entity/customer_order">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'primary'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Ordini fornitore <FontAwesomeIcon icon="receipt" className='ms-1' /></Card.Title>
                                    Gestisci tutti gli ordini fornitore.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="entity/supplier_order">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'success'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Righe aperte <FontAwesomeIcon icon="list" className='ms-1' /></Card.Title>
                                    Vedi le righe aperte.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="/entity/gyv_open_customer_rows">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'danger'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Giacenze <FontAwesomeIcon icon="warehouse" className='ms-1' /></Card.Title>
                                    Vedi le giacenze di magazzino.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="/entity/gyv_stocks">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'dark'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Contatti clienti <FontAwesomeIcon icon="list" className='ms-1' /></Card.Title>
                                    Vedi i conttati dei clienti.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="/entity/customer_contacts">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card bg={'dark'} className='text-light mb-3'>
                                <Card.Body>
                                    <Card.Title>Contatti fornitori <FontAwesomeIcon icon="list" className='ms-1' /></Card.Title>
                                    Vedi i contatti dei fornitori.
                                </Card.Body>
                                <Card.Footer>
                                    <Link to="/entity/supplier_contacts">
                                        <Button variant='light'>Vai al pannello</Button>
                                    </Link>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>

                </Container>
            </> : <>

                <Container>
                    <Row>
                        <Col xs={12} md={4} lg={3}>
                            <Card
                                as={Link}
                                to={"/entity/gyv_supplier_order_2?q=eyJwYWdlIjoxLCJsaW1pdCI6NTAsInNvcnRpbmdGaWVsZCI6ImlkIiwic29ydGluZ09yZGVyIjoiZGVzYyIsImNvbnN0cmFpbnRzIjpbeyJmaWVsZE5hbWUiOiJzdGF0dXMiLCJ0eXBlIjoidmFsdWUiLCJ2YWx1ZSI6IjJfQ09ORklSTUVEIn1dLCJxdWVyeSI6IiJ9"}
                                bg={'primary'}
                                className='text-light mb-3'
                                style={{ textDecoration: 'none', textAlign: 'center' }}
                            >
                                <Card.Body
                                    style={{
                                        minHeight: '150px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Card.Title style={{ textDecoration: 'none' }}>Ordini fornitore</Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card
                                as={Link}
                                to={"/entity/supplier_transport_document?q=eyJwYWdlIjoxLCJsaW1pdCI6NTAsInNvcnRpbmdGaWVsZCI6ImlkIiwic29ydGluZ09yZGVyIjoiZGVzYyIsImNvbnN0cmFpbnRzIjpbeyJmaWVsZE5hbWUiOiJzdGF0dXMiLCJ0eXBlIjoidmFsdWUiLCJ2YWx1ZSI6IjVfUkVBRFkifV0sInF1ZXJ5IjoiIn0%3D"}
                                bg={'success'}
                                className='text-light mb-3'
                                style={{ textDecoration: 'none', textAlign: 'center' }}
                            >
                                <Card.Body
                                    style={{
                                        minHeight: '150px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Card.Title style={{ textDecoration: 'none' }}>DDT fornitore</Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card
                                as={Link}
                                to={"/page/Warehouse"}
                                bg={'secondary'}
                                className='text-light mb-3'
                                style={{ textDecoration: 'none', textAlign: 'center' }}
                            >
                                <Card.Body
                                    style={{
                                        minHeight: '150px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Card.Title style={{ textDecoration: 'none' }}>Carico - Scarico</Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <Card
                                as={Link}
                                to={"entity/gyv_stocks"}
                                bg={'danger'}
                                className='text-light mb-3'
                                style={{ textDecoration: 'none', textAlign: 'center' }}
                            >
                                <Card.Body
                                    style={{
                                        minHeight: '150px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Card.Title style={{ textDecoration: 'none' }}>Giacenze</Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>}
        </>
    )
};
